(function () {
  'use strict';

  function initAuraaWhy(section) {
    if (!section || section.dataset.auraaWhyReady === 'true') return;
    section.dataset.auraaWhyReady = 'true';

    var items = section.querySelectorAll('[data-auraa-reveal]');

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-auraa-why]').forEach(initAuraaWhy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();